module.exports = __webpack_public_path__ + "static/media/bo.003b8ece.svg";